import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { editProfileEvent } from '../../../_events/profile/user_create.event';
import { findLoggedUserEvent } from '../../../_events/profile/find_user.event';
import { message } from "antd";

const Profile = () => {

    const [item, setItem] = useState(null);

    useEffect(() => {
        findLoggedUserEvent()
        .then(data => {
            setItem(data.data);
        })
        .catch(err => {
            message.error(err.message);
        });
    },[]);

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <div style={{display: 'flex', flexDirection: 'row', width:'60%'}}>
                    <Typography variant="h6" component="h6">
                        Perfil
                    </Typography>
                    </div>                    
                </div>
                <hr />
                <UserForm item={item} />               
            </Grid>
        </Grid>
    );
}

const UserForm = (props) => {
    let { item } = props; 

    const editUser = (id) => {
        editProfileEvent(id)
        .then(data => {
            message.success('Actualizado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    return item ? (
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                {
                    item ? item.seller_cod ? 
                    <Grid item xs={12} md={12}>
                        <span style={{marginTop: '10px', marginLeft: '10px'}}><strong>Código vendedor:</strong> {item.seller_cod}</span>       
                    </Grid>
                    : <span style={{marginTop: '10px', marginLeft: '10px'}}><strong>Código vendedor:</strong> Sin código vendedor</span>
                    : <></>
                }
                {
                    item ? item.login ? 
                    <Grid item xs={12} md={12}>
                        <span style={{marginTop: '10px', marginLeft: '10px'}}><strong>Usuario de sistema:</strong> {item.login}</span>       
                    </Grid>
                    : <span style={{marginTop: '10px', marginLeft: '10px'}}>Usuario de sistema: Sin usuario</span>
                    : <></>
                }
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%', marginTop:'10px'}} 
                        id="user_full_name" 
                        label="Nombre completo" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.full_name : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        type={'password'}
                        style={{width: '100%'}} 
                        id="user_password" 
                        label="Contraseña" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.password : null}
                    />  
                </Grid>
                <Grid item xs={12} md={12}>
                    {
                        item ? <Button style={{width: '100%'}} onClick={() => editUser(item.uuid)} variant="contained">Editar</Button>
                        : <></>
                    }      
                </Grid>                
            </Grid>
        </div>
    ) :
    (
        <></>
    )
}

export default Profile;